import { Config } from '../../types/config/config';
import { EnergyRatingOptions, Option } from '../../types/common/option';


export const findOptions = (type: string, config: Config, propertyType: string): Option[] => {

    let options: Option[] = [];
    const configType = type === 'epcrating' ? config.epcRating : config.tenancy

    if(!config || !propertyType || propertyType.length === 0 || !configType){
        return options;
    }

    Object.keys(configType).forEach(key => {
        if(config && configType && configType[key]){
            if(configType[key].values && configType[key].values.indexOf(propertyType) !== -1){
                options = configType[key].options;
            }
        }
    });

    return options;
}

export const findClassByRange = (value: string, config: EnergyRatingOptions[]): string => {
    if (!config || !value) {
        return '';
    }

    const valueNum = parseFloat(value);
    if (isNaN(valueNum)) {
        return '';
    }

    for (const item of config) {
        // Expecting EnergyRatingOptions shape: minValue / maxValue and return the label
        const min = (item as EnergyRatingOptions).minValue;
        const max = (item as EnergyRatingOptions).maxValue;
        if (typeof min === 'number' && typeof max === 'number') {
            if (valueNum >= min && valueNum <= max) {
                return (item as EnergyRatingOptions).label;
            }
        }
    }

    return '';
}